export const prepareCleanedPayload = (apiResponse, data) => {
  return {
    ...apiResponse,
    data: data.map((row) => {
      const updatedRow = { key: row.key };
      let hasError = false;

      Object.keys(row).forEach((fieldKey) => {
        if (["key", "status"].includes(fieldKey)) return;

        const field = row[fieldKey];
        const originalField = apiResponse.data.find((d) => d.key === row.key)?.[
          fieldKey
        ];
        const originalValue = originalField?.value;
        const originalError = originalField?.error;

        const valueChanged =
          JSON.stringify(field?.value) !== JSON.stringify(originalValue);
        const shouldClearError =
          typeof originalError === "string" &&
          originalError?.trim() !== "" &&
          valueChanged;

        const error = shouldClearError ? "" : field.error;
        if (typeof error === "string" && error.trim()) hasError = true;

        let finalValue = field?.value;
        if (
          ["teams", "products"].includes(fieldKey) &&
          Array.isArray(finalValue)
        ) {
          finalValue = finalValue.map((item) =>
            typeof item === "object" ? item.value : item
          );
        } else if (
          [
            "courier",
            "sensor",
            "from_location",
            "to_location",
            "ignore_sensor_measurement_at_start",
          ].includes(fieldKey) &&
          typeof finalValue === "object"
        ) {
          finalValue = finalValue?.value;
        }

        updatedRow[fieldKey] = { ...field, value: finalValue, error };
      });

      updatedRow.status = hasError ? "error" : "";
      return updatedRow;
    }),
  };
};
